import React, {Component} from 'react';
import "./CoOccurrencesViewer.css"
import "./commonAnalysisStyle.css"
import * as d3 from "d3";
import $ from "jquery";


class CoOccurrencesViewer extends Component {

    d3_force = undefined
    nodes = undefined
    links = undefined
    g = undefined

    constructor(props) {
        super(props);
        this.state = {backgroundColor: '#000000', extraction: 'expressions', fromTo: {}}
    }


    componentDidMount() {
        let chart_svg = $("#cooccur_d3view"), container_svg = chart_svg.parent();

        let w = container_svg.width();
        let h = container_svg.height();
        // chart_svg.html("");


        this.d3_force = d3.layout.force().distance(100).charge(-900).linkDistance(150)
            .size([w, h]);

        this.nodes = this.d3_force.nodes()
        this.links = this.d3_force.links();
        let translateX = (w / 2) - 180;
        let translateY = (h / 2) - 160;
        let scaleXY = 0.77

        let vis = d3.select("div#cooccur_d3view").append("svg").attr(
            "viewBox", "0 0 " + w + " " + h).attr("preserveAspectRatio",
            "xMidYMid meet").call(
            d3.behavior.zoom().scaleExtent([-4, 4]).translate([translateX, translateY]).scale(scaleXY, scaleXY).on("zoom", zoom)).on(
            "dblclick.zoom", null).on("wheel.zoom", null);
        ;

        /*
         *
         * .attr("width", w) .attr("height", h)
         */

        this.g = vis.append('g').attr('id', 'viewport');

        let g = this.g;
        g.attr("transform", "translate(" + [translateX, translateY] + ")scale(" + scaleXY + ")");

        function zoom() {
            g.attr("transform", "translate(" + d3.event.translate + ")scale(" + scaleXY + ")");
        }

        this.d3_force.on("tick", function () {
            g.selectAll("g.node").attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")";
            });

            g.selectAll("line.link").attr("x1", function (d) {
                return d.source.x;
            }).attr("y1", function (d) {
                return d.source.y;
            }).attr("x2", function (d) {
                return d.target.x;
            }).attr("y2", function (d) {
                return d.target.y;
            });
        });


        let widget = this;

        $('#CoOccurrencesSearchBoxForm').submit(function (ev) {
            ev.preventDefault(); // to stop the form from submitting
            widget.searchCoOccurrences($("#cooccurence_search_box").val())
        });


        // function zoom() {
        //     g.attr("transform", "translate(" + d3.event.translate + ")scale("
        //         + d3.event.scale + ")");
        // }
        function zoomIn() {
            // translateX = d3.event.translate[0];
            // translateY = d3.event.translate[1];
            scaleXY += scaleXY / 8
            g.attr("transform", "scale("+ scaleXY + ")");

        }

        function zoomOut() {
            // translateX = d3.event.translate[0];
            // translateY = d3.event.translate[1];
            scaleXY -= scaleXY / 8
            g.attr("transform", "scale("+ scaleXY + ")");

        }

        document.getElementById("cooccur_zoom_in").addEventListener("click", (event) => {
            zoomIn()
        });

        document.getElementById("cooccur_zoom_out").addEventListener("click", (event) => {
            zoomOut()
        });

        document.getElementById("cooccurZoomInOut").addEventListener("wheel", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (event.deltaY < 0) {
                zoomOut()
            }
            if (event.deltaY > 0) {
                zoomIn()
            }

        });


    }


    updateCoOccurrenceNetwork(data) {

        $(this.g).empty();


        let jsonNodes = data.expressions;
        let widget = this;
        let nodes = this.nodes;
        let links = this.links;
        let force = this.d3_force;
        let g = this.g;
        let nodeHash = new Array();
        let div = d3.select("body").append("div").attr("class", "tooltip").style(
            "opacity", 0);


        links.splice(0, links.length)
        nodes.splice(0, nodes.length)


        function restart() {


            let link = g.selectAll("line.link").data(links, function (d) {
                return d.source.id + "-" + d.target.id;
            });

            link.enter().insert("svg:line", "g.node").attr("class", "link").attr(
                "fill", "none").attr("stroke", "#ffffff").style("stroke-width", 0.8);

            link.exit().remove();

            let node = g.selectAll("g.node").data(nodes, function (d) {
                return d.id;
            });

            let nodeEnter = node
                .enter()
                .append("svg:g")
                .attr("class", "node")
                .call(force.drag)
                .on("click", function (d, i) {
                    console.log(d);
                    widget.props.callbackParent(d.documents);
                    // clickNode(d, i);
                })
                .on(
                    "mouseover",
                    function (d) {
                        div.transition().duration(200).style("opacity", 1);
                        div.html(
                            "<i><b>" + d.name + "</b></i>"
                            + "<br/>Occurrences: "
                            + d.occurrences
                            + "<br/>Documents: "
                            + d.documents.length + "<br/><span><i>click the node to get documents</i></span></span>").style("left",
                            (d3.event.pageX + 20) + "px").style("top",
                            (d3.event.pageY - 28) + "px");
                        force.stop();
                    }).on("mouseout", function (d) {
                    force.resume();
                    div.transition().duration(500).style("opacity", 0);
                });

            nodeEnter.append("svg:circle").attr("class", "circle").attr("fill",
                "#fc4835").attr("stroke", "#fff").style("stroke-width", 1.5).attr(
                "r", function (d) {
                    return d.weight;
                });

            /*
             * nodeEnter.append("svg:text") .attr("font-size", "10px") .attr("fill",
             * "none") .attr("stroke", "#fff") .attr("stroke-width", "2px")
             * .attr("dx", function(d) { return (d.weight + 4); } ) .attr("dy",
             * ".35em") .text(function(d) { return d.name; });
             */
            var radius = 50;
            var textOffset = 35;
            nodeEnter.append("svg:text").attr("class", "nodetext").attr(
                "font-size", "10px").attr("color", "#000000").attr("dx",
                function (d) {
                    return (d.weight + 4);
                }).attr("transform", function (d) {
                return "translate(" + Math.cos(((d.startAngle + d.endAngle - Math.PI) / 3)) * (radius + textOffset) + "," + Math.sin((d.startAngle + d.endAngle - Math.PI) / 3) * (radius + textOffset) + ")";
            }).attr("dy", ".40em").text(function (d) {
                return d.name;
            });

            node.exit().remove();


        }

        function step1() {

            let maxNodes = 30;

            let nodesNumber = jsonNodes.nodes.length;
            let linksNumber = jsonNodes.links.length;

            if (nodesNumber < maxNodes) {
                maxNodes = nodesNumber;
            }

            for (let x = 0; x < jsonNodes.nodes.length; x++) {
                nodes.push(jsonNodes.nodes[x]);
                nodeHash[jsonNodes.nodes[x].id] = x;
            }

            for (let x = 0; x < jsonNodes.links.length; x++) {
                links.push({
                    source: jsonNodes.nodes[jsonNodes.links[x].source],
                    target: jsonNodes.nodes[jsonNodes.links[x].target],
                    "relation": jsonNodes.links[x].relation,
                    "id": jsonNodes.links[x].id
                });
            }
            restart();

        }

        restart()
        setTimeout(() => {
            step1()
            force.start();
        }, 100);

    }


    searchCoOccurrences(string) {
       // console.log(this.state.fromTo);
        let widget = this;
        let parameters = {
            corpusID: 'deg',
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            keyword: string,
            corpus_language: 'italian',
            interval: 5,
            direction: 'both',
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            dataType: this.state.extraction,
        }

        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "neighbouring_words_detection",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {
                console.log(data);
                widget.updateCoOccurrenceNetwork(data)

            }
        });
    }




    handleOptionChange = (changeEvent) => {
        this.setState({
            extraction: changeEvent.target.value
        }, () => {

        });

    }


    updateTimeInterval(timeInterval, callback) {
        this.setState({fromTo: timeInterval},()=>{
            callback()
        })
    }


    render() {
        return (
            <div id="coOccurrenceDashboard" className="CoOccurrencesWidgetStyle commonAnalysisFeatures">
                <center>
                    <div className="analisysTitle">Co-occorrenze</div>

                    <form id="CoOccurrencesSearchBoxForm" className="form-wrapper">
                        <input id="cooccurence_search_box" type="text" placeholder="Cerca co-occorrenze di..." required/>
                        <button type="submit" style={{color: '#a4becb'}}>Cerca</button>
                    </form>
                </center>
                <div id="cooccurZoomInOut" className="mapboxgl-ctrl mapboxgl-ctrl-group" style={{marginTop: '450px', marginLeft: '10px', float: 'left', position: 'absolute'}}>
                    <button id="cooccur_zoom_in" className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in" type="button" aria-label="Zoom In"/>
                    <button id="cooccur_zoom_out" className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out" type="button" aria-label="Zoom Out"/>
                </div>
                <div id="lista_radio_cooccur" className="radioList" style={{flexWrap: "wrap", display: 'flex'}}>
                    <input className="magic-radio" type="radio" name="radioCoOccur" id="cRadio1" value="expressions" checked={this.state.extraction === 'expressions'} onChange={this.handleOptionChange}/>
                    <label htmlFor="cRadio1">
                        Espressioni
                    </label>
                    <input className="magic-radio" type="radio" name="radioCoOccur" id="cRadio2" value="noun" checked={this.state.extraction === 'noun'} onChange={this.handleOptionChange}/>
                    <label htmlFor="cRadio2">
                        Sostantivi
                    </label>
                    <input className="magic-radio" type="radio" name="radioCoOccur" id="cRadio3" value="adj" checked={this.state.extraction === 'adj'} onChange={this.handleOptionChange}/>
                    <label htmlFor="cRadio3">
                        Aggettivi
                    </label>
                    <input className="magic-radio" type="radio" name="radioCoOccur" id="cRadio4" value="verbs" checked={this.state.extraction === 'verbs'} onChange={this.handleOptionChange}/>
                    <label htmlFor="cRadio4">
                        Verbi
                    </label>
                </div>


                <div style={{overflow: 'hidden', height: '400px'}}>
                    <div id="cooccur_d3view" style={{minWidth: '200px', height: '100%'}}/>
                </div>


            </div>
        );
    }
}


export default CoOccurrencesViewer;


// WEBPACK FOOTER //
// ./src/components/CoOccurrencesViewer.jsx